export const errors = {
  'Orden no existente.':
    'No se ha encontrado los usuarios en el sistema, favor de corroborar el ID de la cita',
  default: 'Error desconocido, vuelva a intentar más tarde',
};
